const NavController = {
    Load: () => {
        const nav = document.getElementById('vert-nav');
        const navBtn = document.querySelector('.nav-menu-icon');
        const overflowBtn = document.querySelector('.overflow-icon');
        const layoutD = document.getElementById('LayoutD');

        const handleClick = (e) => {
            e.stopPropagation();
            if (!layoutD) {
                let overflowBtnWidth = overflowBtn.offsetWidth;
                if (overflowBtnWidth !== 0) {
                    nav.style.width = overflowBtnWidth * .93 + "px";
                } else {
                    let navBtnWidth = navBtn.offsetWidth;
                    nav.style.width = navBtnWidth * .93 + "px";
                }
            }
            navToggle();
        }

        const offClick = () => {
            clearDropdown();
        }

        function navToggle() {
            if (nav.style.display === 'flex') {
                nav.style.display = 'none';
                document.removeEventListener('click', offClick);
            } else {
                nav.style.display = 'flex';
                document.addEventListener('click', offClick);
            }
        }

        function clearDropdown(){
            nav.style.display = 'none';
            document.removeEventListener('click', offClick);
        }

        navBtn.addEventListener('click', handleClick);
        overflowBtn?.addEventListener('click', handleClick);
    }
}

export default NavController;